const unprocessedRouter = {
    path: "unprocessed",
    name: "unprocessed",
    meta: {
        title: "待处理"
    },
    component: () => import("@/pages/index/home/unprocessed/Unprocessed"),
    redirect: {
        name: "my-unprocessed"
    },
    children: [
        {
            path: "my-unprocessed",
            name: "my-unprocessed",
            meta: {
                title: "待处理-列表页"
            },
            component: () => import("@/pages/index/home/unprocessed/List")
        },
        {
            path: "all-unprocessed",
            name: "all-unprocessed",
            meta: {
                title: "待处理-列表页"
            },
            component: () => import("@/pages/index/home/unprocessed/List")
        },
        {
            path: "my-expired-project",
            name: "my-expired-project",
            meta: {
                title: "待处理-列表页"
            },
            component: () => import("@/pages/index/home/unprocessed/List")
        },
        {
            path: "all-expired-project",
            name: "all-expired-project",
            meta: {
                title: "待处理-列表页"
            },
            component: () => import("@/pages/index/home/unprocessed/List")
        }
    ]
};
export default unprocessedRouter;



// WEBPACK FOOTER //
// ./src/router/index/home/unprocessed.js